import { SuccessAction } from "./action-types";
import ViewerMethod from "./ViewerMethod";
import { getSuccessActionName } from "./make-action";
import { emitExternalEvent } from "../../../../../external/internal/events";

const apiEventTypes = [
  ViewerMethod.DELETE_HIGHLIGHT,
  ViewerMethod.UPDATE_HIGHLIGHT,
  ViewerMethod.HIGHLIGHT_CURRENT_SELECTION,
];

/**
 * Redux-action-derived events emitted to consumers who are using supernova
 * with the script-based instantiation API
 */
export default function processActionForEventEmission(
  reduxAction: SuccessAction
) {
  const apiName = apiEventTypes.find(
    (name) => getSuccessActionName(name) === reduxAction.type
  );
  if (apiName) {
    emitExternalEvent(`${apiName}/success`, {
      ok: true,
      data: reduxAction.resultData,
      status: reduxAction.resultStatus,
      args: reduxAction.apiCallArgs,
    });
  }
}
